<form
  class="insured-form"
  [formGroup]="formularioAsegurado"
  novalidate
  (ngSubmit)="continuar()"
>
  <div class="insured-profile">
    <span>Perfil:</span>
    <strong>Asegurado</strong>
  </div>

  <section class="insured-alert">
    <span class="insured-alert__icon">
      <mat-icon>verified_user</mat-icon>
    </span>

    <div>
      <h2>Verificamos tus datos para proteger tu cuenta</h2>
      <p>Ten a la mano una póliza vigente de Seguros Atlas.</p>
    </div>
  </section>

  <section class="insured-section">
    <header class="insured-section__header">
      <mat-icon>lock</mat-icon>
      <h3>Datos de acceso</h3>
    </header>

    <div class="insured-access-card">
      <div
        class="insured-access-card__email-row"
        [class.insured-access-card__email-row--full]="!dosFaCorreoHabilitado"
      >
        <div
          class="insured-field insured-field--with-field-error insured-access-card__email"
          [class.insured-field--invalid]="isInvalid('Email')"
        >
          <label for="insured-email">Email*</label>
          <input
            id="insured-email"
            name="atlas-reg-insured-email"
            type="email"
            formControlName="Email"
            placeholder="correo@ejemplo.com"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="none"
            spellcheck="false"
            readonly
            (focus)="desbloquearAutofill($event)"
            (blur)="bloquearAutofill($event); verificarCorreoAlPerderFoco()"
            data-lpignore="true"
            data-1p-ignore="true"
            data-form-type="other"
          />

          @if (isInvalid("Email")) {
            <button
              type="button"
              class="insured-field__alert-button insured-field__alert-button--field insured-field__alert-button--error"
              aria-label="Ver detalle del correo electrónico"
              (mousedown)="$event.preventDefault()"
              (click)="abrirErrorCampo('Email')"
            >
              <mat-icon>error_outline</mat-icon>
            </button>
          } @else if (
            formularioAsegurado.controls.Email.value &&
            formularioAsegurado.controls.Email.valid
          ) {
            <span
              class="insured-field__status"
              role="status"
              aria-label="Correo electrónico válido"
            >
              <mat-icon
                class="insured-field__status-icon insured-field__status-icon--success"
              >
                check_circle
              </mat-icon>
            </span>
          }

          @if (isInvalid("Email")) {
            <small>{{ getError("Email") }}</small>
          }
        </div>

        <div
          class="insured-access-card__email-action"
          [class.insured-access-card__email-action--hidden]="!dosFaCorreoHabilitado"
        >
          <button
            type="button"
            class="insured-verify-button"
            [class.insured-verify-button--ok]="
              !dosFaCorreoHabilitado || validandoCorreo
            "
            [disabled]="
              consultandoNormaCorreo ||
              !dosFaCorreoHabilitado ||
              formularioAsegurado.controls.Email.invalid ||
              procesandoCorreo ||
              validandoCorreo
            "
            (click)="verificarCorreo()"
          >
            <mat-icon
              [class.insured-verify-button__icon--spin]="
                consultandoNormaCorreo || procesandoCorreo
              "
            >
              {{
                !dosFaCorreoHabilitado || validandoCorreo
                  ? "check_circle"
                  : consultandoNormaCorreo || procesandoCorreo
                    ? "sync"
                    : "mail"
              }}
            </mat-icon>

            @if (dosFaCorreoHabilitado) {
              <span>
                {{
                  consultandoNormaCorreo
                    ? "Consultando"
                    : validandoCorreo
                      ? "Verificado"
                      : procesandoCorreo
                        ? "Enviando"
                        : "Click para verificar"
                }}
              </span>
            }
          </button>
        </div>
      </div>

      <div class="insured-access-card__password-row">
        <div
          class="insured-field insured-field--password insured-access-card__half"
          [class.insured-field--invalid]="isInvalid('Password')"
        >
          <label for="insured-password">Contraseña*</label>
          <input
            id="insured-password"
            name="atlas-reg-insured-password"
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="Password"
            placeholder="Ingresa tu contraseña"
            autocomplete="new-password"
            autocorrect="off"
            autocapitalize="none"
            spellcheck="false"
          />

          <span class="insured-field__actions">
            <button
              type="button"
              class="insured-field__icon-button"
              [attr.aria-label]="
                hidePassword ? 'Mostrar contraseña' : 'Ocultar contraseña'
              "
              (click)="hidePassword = !hidePassword"
            >
              <mat-icon>{{
                hidePassword ? "visibility_off" : "visibility"
              }}</mat-icon>
            </button>

            @if (validandoPassword) {
              <mat-icon
                class="insured-field__status-icon insured-field__status-icon--pending"
              >
                sync
              </mat-icon>
            } @else if (mostrarIconoPasswordCorrecto()) {
              <mat-icon
                class="insured-field__status-icon insured-field__status-icon--success"
              >
                check_circle
              </mat-icon>
            } @else if (mostrarIconoPasswordError()) {
              <button
                type="button"
                class="insured-field__alert-button insured-field__alert-button--error"
                aria-label="Ver reglas de contraseña"
                (click)="abrirErroresPassword()"
              >
                <mat-icon>error_outline</mat-icon>
              </button>
            } @else if (isInvalid("Password")) {
              <button
                type="button"
                class="insured-field__alert-button insured-field__alert-button--error"
                aria-label="Ver detalle de contraseña"
                (click)="abrirErrorCampo('Password')"
              >
                <mat-icon>error_outline</mat-icon>
              </button>
            }
          </span>

          @if (isInvalid("Password")) {
            <small>{{ getError("Password") }}</small>
          }
        </div>

        <div
          class="insured-field insured-field--password insured-access-card__half"
          [class.insured-field--invalid]="isInvalid('ConfirmaPassword')"
        >
          <label for="insured-confirm-password">Confirma contraseña*</label>
          <input
            id="insured-confirm-password"
            name="atlas-reg-insured-confirm-password"
            [type]="hideConfirmPassword ? 'password' : 'text'"
            formControlName="ConfirmaPassword"
            placeholder="Confirma tu contraseña"
            autocomplete="new-password"
            autocorrect="off"
            autocapitalize="none"
            spellcheck="false"
          />

          <span class="insured-field__actions">
            <button
              type="button"
              class="insured-field__icon-button"
              [attr.aria-label]="
                hideConfirmPassword
                  ? 'Mostrar confirmación'
                  : 'Ocultar confirmación'
              "
              (click)="hideConfirmPassword = !hideConfirmPassword"
            >
              <mat-icon>{{
                hideConfirmPassword ? "visibility_off" : "visibility"
              }}</mat-icon>
            </button>

            @if (mostrarIconoConfirmaPasswordCorrecto()) {
              <mat-icon
                class="insured-field__status-icon insured-field__status-icon--success"
              >
                check_circle
              </mat-icon>
            } @else if (isInvalid("ConfirmaPassword")) {
              <button
                type="button"
                class="insured-field__alert-button insured-field__alert-button--error"
                aria-label="Ver error de confirmación"
                (click)="abrirErrorCampo('ConfirmaPassword')"
              >
                <mat-icon>error_outline</mat-icon>
              </button>
            }
          </span>

          @if (isInvalid("ConfirmaPassword")) {
            <small>{{ getError("ConfirmaPassword") }}</small>
          }
        </div>
      </div>

      <div
        class="insured-field insured-field--full insured-field--alias"
        [class.insured-field--invalid]="isInvalid('Alias')"
      >
        <label for="insured-alias">Alias o sobrenombre*</label>
        <input
          id="insured-alias"
          name="atlas-reg-insured-alias"
          type="text"
          formControlName="Alias"
          placeholder="Ej. Auto familiar"
          autocomplete="off"
          maxlength="100"
          autocorrect="off"
          spellcheck="false"
        />

        @if (isInvalid("Alias")) {
          <button
            type="button"
            class="insured-field__alert-button insured-field__alert-button--field insured-field__alert-button--error"
            aria-label="Ver detalle del alias"
            (click)="abrirErrorCampo('Alias')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        } @else {
          <button
            type="button"
            class="insured-field__alert-button insured-field__alert-button--field insured-field__alert-button--info"
            aria-label="Información sobre el alias"
            (click)="abrirInfoAlias()"
          >
            <mat-icon>info_outline</mat-icon>
          </button>
        }

        @if (isInvalid("Alias")) {
          <small>{{ getError("Alias") }}</small>
        }
      </div>
    </div>
  </section>

  <section class="insured-section">
    <header class="insured-section__header">
      <mat-icon>verified_user</mat-icon>
      <h3>Verificación de contacto</h3>
    </header>

    <div
      class="insured-contact-card insured-contact-card--phone-only"
      [class.insured-contact-card--phone-full]="!dosFaTelefonoHabilitado"
    >
      <div
        class="insured-field insured-field--phone insured-field--with-field-error"
        [class.insured-field--invalid]="isInvalid('Telefono')"
      >
        <label for="insured-phone">Teléfono celular*</label>

        <div class="insured-phone-control">
          <div class="insured-phone-control__select-wrapper insured-select insured-select--compact">
            <select
              class="insured-phone-control__select insured-select__control"
              aria-label="Código de país"
              [value]="codigoPaisTelefonoSeleccionadoKey"
              (change)="seleccionarCodigoPaisTelefono($event)"
            >
              @for (
                pais of codigosPaisTelefono;
                track getCodigoPaisTelefonoKey(pais)
              ) {
                <option [value]="getCodigoPaisTelefonoKey(pais)">
                  {{ pais.pais }} +{{ pais.codigo }}
                </option>
              }
            </select>
            <mat-icon class="insured-select__chevron"
              >keyboard_arrow_down</mat-icon
            >
          </div>

          <input
            id="insured-phone"
            name="atlas-reg-insured-phone"
            type="text"
            inputmode="numeric"
            [value]="telefonoLocal"
            maxlength="10"
            placeholder="10 dígitos"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="none"
            spellcheck="false"
            readonly
            (focus)="desbloquearAutofill($event)"
            (input)="capturarTelefonoLocal($event)"
            (blur)="bloquearAutofill($event); verificarTelefonoAlPerderFoco()"
            data-lpignore="true"
            data-1p-ignore="true"
            data-form-type="other"
          />
        </div>

        @if (isInvalid("Telefono")) {
          <button
            type="button"
            class="insured-field__alert-button insured-field__alert-button--field insured-field__alert-button--error"
            aria-label="Ver detalle del teléfono celular"
            (mousedown)="$event.preventDefault()"
            (click)="abrirErrorCampo('Telefono')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        } @else if (telefonoTieneFormatoCorrecto()) {
          <span
            class="insured-field__status"
            role="status"
            aria-label="Teléfono celular válido"
          >
            <mat-icon
              class="insured-field__status-icon insured-field__status-icon--success"
            >
              check_circle
            </mat-icon>
          </span>
        }

        @if (isInvalid("Telefono")) {
          <small>{{ getError("Telefono") }}</small>
        }
      </div>

      <button
        type="button"
        class="insured-verify-button"
        [class.insured-verify-button--hidden]="!dosFaTelefonoHabilitado"
        [class.insured-verify-button--ok]="
          !dosFaTelefonoHabilitado || validandoTelefono
        "
        [disabled]="!telefonoPuedeVerificarse()"
        (click)="verificarTelefono()"
      >
        <mat-icon
          [class.insured-verify-button__icon--spin]="
            consultandoNormaTelefono || procesandoTelefono
          "
        >
          {{
            !dosFaTelefonoHabilitado || validandoTelefono
              ? "check_circle"
              : consultandoNormaTelefono || procesandoTelefono
                ? "sync"
                : "phone_iphone"
          }}
        </mat-icon>
        @if (dosFaTelefonoHabilitado) {
          <span>
            {{
              consultandoNormaTelefono
                ? "Consultando"
                : validandoTelefono
                  ? "Verificado"
                  : procesandoTelefono
                    ? "Enviando"
                    : "Click para verificar"
            }}
          </span>
        }
      </button>
    </div>
  </section>

  <section class="insured-section">
    <header
      class="insured-section__header insured-section__header--with-action"
    >
      <span class="insured-section__title">
        <mat-icon>description</mat-icon>
        <h3>Datos de la póliza</h3>
      </span>

      <button
        type="button"
        class="insured-help-button"
        (click)="abrirAyudaPoliza()"
      >
        <mat-icon>help_outline</mat-icon>
        <span>¿Dónde encuentro estos datos?</span>
      </button>
    </header>

    <div class="insured-policy-card">
      <div class="insured-policy-main">
        <div class="insured-policy-sequence">
          <div
            class="insured-policy-segment"
            [class.insured-policy-segment--invalid]="isInvalid('Sucursal')"
          >
            <label for="insured-policy-branch">Sucursal*</label>
            <input
              id="insured-policy-branch"
              name="atlas-reg-policy-branch"
              type="text"
              formControlName="Sucursal"
              maxlength="3"
              placeholder="001"
              autocomplete="off"
              aria-label="Sucursal"
              (input)="capturarSucursal($event)"
            />
          </div>

          <span class="insured-policy-separator" aria-hidden="true">-</span>

          <div
            class="insured-policy-segment"
            [class.insured-policy-segment--invalid]="isInvalid('Linea')"
          >
            <label for="insured-policy-line">Línea*</label>
            <input
              #inputLinea
              id="insured-policy-line"
              name="atlas-reg-policy-line"
              type="text"
              inputmode="numeric"
              formControlName="Linea"
              maxlength="1"
              placeholder="8"
              autocomplete="off"
              aria-label="Línea"
              (input)="capturarLinea($event)"
            />
          </div>

          <span class="insured-policy-separator" aria-hidden="true">-</span>

          <div
            class="insured-policy-segment"
            [class.insured-policy-segment--invalid]="isInvalid('Producto')"
          >
            <label for="insured-policy-product">Producto*</label>
            <input
              #inputProducto
              id="insured-policy-product"
              name="atlas-reg-policy-product"
              type="text"
              inputmode="numeric"
              formControlName="Producto"
              maxlength="3"
              placeholder="024"
              autocomplete="off"
              aria-label="Producto"
              (input)="capturarNumerico($event, 'Producto', 3)"
            />
          </div>

          <span class="insured-policy-separator" aria-hidden="true">-</span>

          <div
            class="insured-policy-segment insured-policy-segment--number"
            [class.insured-policy-segment--invalid]="isInvalid('Poliza')"
          >
            <label for="insured-policy-number">Póliza*</label>
            <input
              #inputPoliza
              id="insured-policy-number"
              name="atlas-reg-policy-number"
              type="text"
              inputmode="numeric"
              formControlName="Poliza"
              maxlength="8"
              placeholder="12345678"
              autocomplete="off"
              aria-label="Póliza"
              (input)="capturarNumerico($event, 'Poliza', 8)"
            />
          </div>
        </div>

        @if (
          isInvalid("Sucursal") ||
          isInvalid("Linea") ||
          isInvalid("Producto") ||
          isInvalid("Poliza")
        ) {
          <div class="insured-policy-errors" role="alert">
            @if (isInvalid("Sucursal")) {
              <small>Sucursal: {{ getError("Sucursal") }}</small>
            }
            @if (isInvalid("Linea")) {
              <small>Línea: {{ getError("Linea") }}</small>
            }
            @if (isInvalid("Producto")) {
              <small>Producto: {{ getError("Producto") }}</small>
            }
            @if (isInvalid("Poliza")) {
              <small>Póliza: {{ getError("Poliza") }}</small>
            }
          </div>
        }
      </div>

      <div
        class="insured-policy-details"
        [class.insured-policy-details--three-columns]="
          mostrarCampoPoliza('Seccion')
        "
      >
        <div
          class="insured-field"
          [class.insured-field--invalid]="isInvalid('FechaInicioVigencia')"
        >
          <label for="insured-policy-date">
            Inicio de vigencia de la póliza*
          </label>
          <input
            #inputFechaInicio
            id="insured-policy-date"
            name="atlas-reg-policy-date"
            type="date"
            formControlName="FechaInicioVigencia"
            autocomplete="off"
          />

          @if (isInvalid("FechaInicioVigencia")) {
            <small>{{ getError("FechaInicioVigencia") }}</small>
          }
        </div>

        @if (mostrarCampoPoliza("Inciso")) {
          <div
            class="insured-field"
            [class.insured-field--invalid]="isInvalid('Inciso')"
          >
            <label for="insured-policy-inciso">Inciso*</label>
            <input
              id="insured-policy-inciso"
              name="atlas-reg-policy-inciso"
              type="number"
              min="0"
              formControlName="Inciso"
              placeholder="Ingresa el inciso"
              autocomplete="off"
            />
            @if (isInvalid("Inciso")) {
              <small>{{ getError("Inciso") }}</small>
            }
          </div>
        }
        @if (mostrarCampoPoliza("Ubicacion")) {
          <div
            class="insured-field"
            [class.insured-field--invalid]="isInvalid('Ubicacion')"
          >
            <label for="insured-policy-location">Ubicación*</label>
            <input
              id="insured-policy-location"
              name="atlas-reg-policy-location"
              type="number"
              min="0"
              formControlName="Ubicacion"
              placeholder="Ingresa la ubicación"
              autocomplete="off"
            />
            @if (isInvalid("Ubicacion")) {
              <small>{{ getError("Ubicacion") }}</small>
            }
          </div>
        }
        @if (mostrarCampoPoliza("Certificado")) {
          <div
            class="insured-field"
            [class.insured-field--invalid]="isInvalid('Certificado')"
          >
            <label for="insured-policy-certificate">Certificado*</label>
            <input
              id="insured-policy-certificate"
              name="atlas-reg-policy-certificate"
              type="number"
              min="0"
              formControlName="Certificado"
              placeholder="Ingresa el certificado"
              autocomplete="off"
            />
            @if (isInvalid("Certificado")) {
              <small>{{ getError("Certificado") }}</small>
            }
          </div>
        }
        @if (mostrarCampoPoliza("Seccion")) {
          <div
            class="insured-field"
            [class.insured-field--invalid]="isInvalid('Seccion')"
          >
            <label for="insured-policy-section">Sección*</label>
            <input
              id="insured-policy-section"
              name="atlas-reg-policy-section"
              type="number"
              min="0"
              formControlName="Seccion"
              placeholder="Ingresa la sección"
              autocomplete="off"
            />
            @if (isInvalid("Seccion")) {
              <small>{{ getError("Seccion") }}</small>
            }
          </div>
        }
      </div>
    </div>
  </section>

  <section class="insured-section">
    <header class="insured-section__header">
      <mat-icon>vpn_key</mat-icon>
      <h3>Pregunta de seguridad</h3>
    </header>

    <div class="insured-fields-card">
      <div
        class="insured-field insured-field--select insured-field--select-error"
        [class.insured-field--invalid]="isInvalid('IdPregunta')"
      >
        <label for="insured-secret-question">Pregunta secreta*</label>
        <div class="insured-select">
          <select
            id="insured-secret-question"
            class="insured-select__control"
            name="atlas-reg-secret-question"
            formControlName="IdPregunta"
            autocomplete="off"
          >
            <option [ngValue]="null">Selecciona una pregunta</option>
            @for (pregunta of catPreguntas; track pregunta.Value) {
              <option [ngValue]="pregunta.Value">{{ pregunta.Text }}</option>
            }
          </select>
          <mat-icon class="insured-select__chevron"
            >keyboard_arrow_down</mat-icon
          >
        </div>

        @if (isInvalid("IdPregunta")) {
          <button
            type="button"
            class="insured-field__alert-button insured-field__alert-button--field insured-field__alert-button--error"
            aria-label="Ver detalle de pregunta secreta"
            (click)="abrirErrorCampo('IdPregunta')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid("IdPregunta")) {
          <small>{{ getError("IdPregunta") }}</small>
        }
      </div>

      <div
        class="insured-field insured-field--with-field-error"
        [class.insured-field--invalid]="isInvalid('Respuesta')"
      >
        <label for="insured-secret-answer">Respuesta*</label>
        <input
          id="insured-secret-answer"
          name="atlas-reg-secret-answer"
          type="text"
          formControlName="Respuesta"
          placeholder="Escribe tu respuesta"
          autocomplete="new-password"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
        />

        @if (isInvalid("Respuesta")) {
          <button
            type="button"
            class="insured-field__alert-button insured-field__alert-button--field insured-field__alert-button--error"
            aria-label="Ver detalle de respuesta"
            (click)="abrirErrorCampo('Respuesta')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid("Respuesta")) {
          <small>{{ getError("Respuesta") }}</small>
        }
      </div>
    </div>
  </section>

  <div class="insured-actions">
    <button
      type="button"
      class="insured-button insured-button--secondary"
      [disabled]="loadingRegistro"
      (click)="regresar()"
    >
      Regresar
    </button>

    <button
      type="submit"
      class="insured-button insured-button--primary"
      [disabled]="loadingRegistro"
    >
      {{ loadingRegistro ? "Registrando..." : "Continuar" }}
    </button>
  </div>
</form>
